import { GET_ALL_ENTITYS_SUCCESS } from '../actions/actionTypes';

export default function allEntities(state = [], action) {
  switch (action.type) {
    case GET_ALL_ENTITYS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
